import { notification, Typography } from 'antd';
import React from 'react';

import { SendUserMessageForm } from '../../../components/SendUserMessageForm';
import { apiClient } from '../../../graphql/api/apiClient';
import { usesendInvitationMutation } from '../../../graphql/api/generated';
import type { UserRowFragment } from '../../../graphql/hasura/generated';

interface ISendUserInvitationProps {
  user: UserRowFragment;
  closeModal: () => void;
}

export const SendUserInvitation: React.FC<ISendUserInvitationProps> = (props) => {
  const { user, closeModal } = props;

  const [sendInvitation, { loading }] = usesendInvitationMutation({
    client: apiClient,
  });

  return (
    <SendUserMessageForm
      user={user}
      onSubmit={async (messageMethod) => {
        await sendInvitation({
          variables: {
            input: {
              messageMethod,
              userId: user.userId,
            },
          },
        });

        notification.success({
          message: 'Success',
          description: `The invitation was sent successfully!`,
        });

        closeModal();
      }}
      onCancel={closeModal}
      submitting={loading}
      description={(
        <Typography.Paragraph>
          Send this user a link to download the Chirp Access App:
        </Typography.Paragraph>
      )}
    />
  );
};
